import {
  FETCH_ALL,
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  START_LOADING,
  SOFTDELETE,
  FETCH_DELETED_INVOICES,
  FETCH_CANCELED_INVOICES,
  FETCH_COMPLIMENTARY_INVOICES,
  CANCEL_INVOICE,
  END_LOADING,
  FETCH_INVOICE_BY_USER,
  FETCH_INVOICE_BY_CLIENT,
} from "../actions/constants";
import { idsMatch } from "../utils/ids";

const invoices = (
  state = { isLoading: true, invoices: [], deletedInvoices: [], canceledInvoices: [], complimentaryInvoices: [] },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ALL:
      return {
        ...state,
        invoices: action.payload,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_INVOICE_BY_USER:
      return { ...state, invoices: action.payload };
    case FETCH_INVOICE_BY_CLIENT:
      return {
        ...state,
        invoices: action.payload.invoices,
        numberOfPages: action.payload.totalItems,
        totalAmount: action.payload.totalAmount,
      };
    case GET_INVOICE:
      return { ...state, invoice: action.payload };
    case ADD_NEW:
      return { ...state, invoices: [...state.invoices, action.payload] };
    case UPDATE:
      if (state.invoices && state.invoices.data && Array.isArray(state.invoices.data)) {
        return {
          ...state,
          invoices: {
            ...state.invoices,
            data: state.invoices.data.map((invoice) =>
              idsMatch(invoice.id, action.payload.id) ? action.payload : invoice
            )
          }
        };
      } else if (Array.isArray(state.invoices)) {
        return {
          ...state,
          invoices: state.invoices.map((invoice) =>
            idsMatch(invoice.id, action.payload.id) ? action.payload : invoice
          ),
        };
      }
      return state;
    case DELETE:
      return {
        ...state,
        invoices: state.invoices.filter(
          (invoice) => !idsMatch(invoice.id, action.payload)
        ),
      };
    case SOFTDELETE:
      // Handle both paginated and non-paginated data structures
      if (state.invoices && state.invoices.data && Array.isArray(state.invoices.data)) {
        // Paginated structure
        return {
          ...state,
          invoices: {
            ...state.invoices,
            data: state.invoices.data.filter(
              (invoice) => !idsMatch(invoice.id, action.payload)
            ),
            pagination: {
              ...state.invoices.pagination,
              totalCount: state.invoices.pagination.totalCount - 1
            }
          },
        };
      } else if (Array.isArray(state.invoices)) {
        // Non-paginated structure (legacy)
        return {
          ...state,
          invoices: state.invoices.filter(
            (invoice) => !idsMatch(invoice.id, action.payload)
          ),
        };
      }
      return state;
    case FETCH_DELETED_INVOICES:
      return { ...state, deletedInvoices: action.payload };
    case FETCH_CANCELED_INVOICES:
      return { ...state, canceledInvoices: action.payload };
    case FETCH_COMPLIMENTARY_INVOICES:
      return { ...state, complimentaryInvoices: action.payload };
    case CANCEL_INVOICE:
      // Handle both paginated and non-paginated data structures
      if (state.invoices && state.invoices.data && Array.isArray(state.invoices.data)) {
        // Paginated structure
        return {
          ...state,
          invoices: {
            ...state.invoices,
            data: state.invoices.data.filter(
              (invoice) => !idsMatch(invoice.id, action.payload)
            ),
            pagination: {
              ...state.invoices.pagination,
              totalCount: state.invoices.pagination.totalCount - 1
            }
          },
        };
      } else if (Array.isArray(state.invoices)) {
        // Non-paginated structure (legacy)
        return {
          ...state,
          invoices: state.invoices.filter(
            (invoice) => !idsMatch(invoice.id, action.payload)
          ),
        };
      }
      return state;
    default:
      return state;
  }
};

export default invoices;

//   const invoices =( state = { invoices: [], }, action ) => {
//     switch (action.type) {
//         case FETCH_ALL:
//             return { ...state, invoices: action.payload }

//         case GET_INVOICE:
//             return { ...state, invoice: action.payload }

//         case ADD_NEW:
//             return { ...state, invoices: [...state.invoices, action.payload] }

//         case UPDATE:
//             return { ...state, invoices: state.invoices.map((invoice) => invoice.id === action.payload ? action.payload : invoice) }

//         case DELETE:
//         return {...state, invoices: state.invoices.filter((invoice) => invoice.id !== action.payload)}

//         default:
//             return state;
//     }
// }

// export default invoices
